<div class="login-card">
  <div class="login-header">
    <img src="assets/traton-logo.jpg" alt="TRATON Logo" class="login-logo" />
  </div>
  <div class="login-body">
    <p class="login-instruction">Sign in with your corporate ID</p>
    <div class="brand-buttons">
      @if(ifCNRegion) {
        <button class="brand-btn" (click)="login('cn')">
          SCANIACN
        </button>
      } @else {
        <button class="brand-btn" (click)="login('com')">
          SCANIA
        </button>
        <button class="brand-btn" (click)="login('cn')">
          SCANIACN
        </button>
        <button class="brand-btn" (click)="login('international')">
          INTERNATIONAL
        </button>
      }
    </div>
  </div>
</div>